import { useState, useEffect/*, useRef*/ } from "react";
import { connect } from "react-redux";
import FormLayout from "../../components/layouts/FormLayout";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import TabComponent from "../../components/TabsComponent/TabComponent";
import {Grid, MenuItem} from "@material-ui/core";
import MonitoringView from "./monitoring.view";
import CustomForms from "../customForms/customForms.view";
import { MonitoringDashBoard } from "./monitoringDashboard";
import ControlledInputRoundedForm from "../../components/InputForm/ControlledInputRoundedForm";
import Tooltip from "@material-ui/core/Tooltip";
import SwitchForm from "../../components/Switch/switchForm.component";

//#region Entity's dependencies
import { getTransactionTypesByEnterprise } from "../../actions/objecttype.action";
//#endregion

/**
 * TracingForm Component ( full view for form to create/modify integration )
 *
 * @export Class Component
 * @extends {Component}
 * @returns Redux connect
 */
const TracingForm = (props) => {
  /* #region  Props */
  const {
    user,
    userPrivileges,
    setLoading,
    enterpriseRecord,
    getTransactionTypesByEnterprise,
    transactionTypesResponse
  } = props;

  const[objectTypeInit] = useState(
    {id:"pifeventlog", value: "pifeventlog", name:"Log de eventos", selected:true, filter:""}
  );
  const[objectTypes, setObjectTypes] = useState([objectTypeInit]);
  /* #endregion */

  /* #region  States */
  const [tab, setTab] = useState(0);
  const [confirmInactivate, setConfirmInactivate] = useState({
    open: false,
    checked: false,
    back: false,
    cancelEdit: false,
    changeTab: false,
    newTab: 0,
  });
  const [withoutFiltersChecked, setWithoutFiltersChecked] = useState(false);
  /* #endregion */

  //#region react hook form config
  const requiredMessage = "Campo obligatorio.";
  const validationSchema = Yup.object().shape({
    objectType: Yup.string().required(requiredMessage),
  });
  const {
    control,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      objectType: objectTypeInit.id
    },
    resolver: yupResolver(validationSchema),
    shouldUnregister: false,
    mode: "onChange",
  });
  //#endregion

  /* #region  useEffect */
  useEffect(() => {
    if(enterpriseRecord.id)
      getTransactionTypesByEnterprise(enterpriseRecord.name);
      
  }, [getTransactionTypesByEnterprise, enterpriseRecord]);

  useEffect(() => {
    if (transactionTypesResponse && transactionTypesResponse.length) {
      const transactionTypes = [];
      transactionTypesResponse.filter(type=> type.idstate === 0).sort((a,b)=>{return a.name===b.name?0:a.name<b.name?-1:1;}).forEach(transactionType => {
        const objtransactionType = jsonParse(transactionType.description);
        if(objtransactionType && objtransactionType.id && objtransactionType.visibility !== false){
          const type_ = {
            id: objtransactionType.id
            , value: objtransactionType.value
            , name: objtransactionType.name
            , selected: objtransactionType.selected
            , filter: objtransactionType.filter
            , fields: objtransactionType.fields
            , timeLineIdProperty: objtransactionType.timeLineIdProperty
            , entityView: objtransactionType.entityView
            , log_: objtransactionType.log_
            , method: objtransactionType.method
          };
          transactionTypes.push(type_);
          if(objtransactionType.selected){
            setValue("objectType",objtransactionType.id);
          }
        }
      });
      setObjectTypes(transactionTypes);
    }
    // eslint-disable-next-line
  }, [transactionTypesResponse]);
  /* #endregion */

  const jsonParse = (value, initialValue = {}, callback)=>{
    let obj = initialValue;
    try{
      obj = JSON.parse(value);
    } catch (ex){
      if(callback)
        callback(ex);
    }
    return obj;
  }

  const handleChangeTab = async (event, newTab) => {
    event.preventDefault();
    setTab(newTab);
  };

  const handleAccept = (e) => {
    setConfirmInactivate((state) => ({
      ...state,
      open: false,
    }));
  };

  /*const defineSubHeader = () => {
    let subheader = "";
    switch (tab) {
      case 0: 
        subheader = "Panel de control";
        break;
      case 1:
        subheader = "Bitácora de errores";
        break;
      case 2:
        subheader = "Detalle de transacciones";
        break;
      default:
        subheader = "Nuevo monitoreo";
        break;
    }
    return subheader;
  };*/

  const childrenForm = [];

  if(userPrivileges.dashboard)
    childrenForm.push(
      {
        label: "Indicadores",
        tabContent: (
          <Grid container style={{
              display: "flex",
            }}>
            <MonitoringDashBoard 
            enterpriseRecord={enterpriseRecord} />
          </Grid>
        ),
      });

  if(userPrivileges.transaction)
    childrenForm.push({
        label: "Transacciones",
        tabContent: (
          <Grid container style={{
            display: "flex"
          }}>
            <Grid
              item
              sm={4}
              xs={12}
              style={{ marginRight: "10px" }}
            >
              <ControlledInputRoundedForm
                id="objectType"
                name="objectType"
                label="Integración"
                control={control}
                fullWidth
                select
                style={{ marginLeft: "10px", marginTop: "10px" }}
              >
                {objectTypes.map((option) => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    selected={option.selected}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </ControlledInputRoundedForm>
            </Grid>
            <Grid item xs={12}>
            {objectTypes.filter(o=>o.id === watch("objectType")).map(objectType => (
              <>
              {objectType.filter && (
                <Grid container item xs={12} style={{marginLeft:"20px"}}>
                  <Tooltip title="Sin filtros base">
                    <SwitchForm
                      name="withoutFilters"
                      onChange={(event) => {
                        setWithoutFiltersChecked(event.target.checked);
                      }}
                      checked={withoutFiltersChecked}
                    />
                  </Tooltip>
                  Sin filtros base
                </Grid>
              )}
                <CustomForms 
                  entityDefault={objectType.value} 
                  onlyContent={true} 
                  searchInit={withoutFiltersChecked ? "" : objectType.filter} 
                  fields={objectType.fields} 
                  timeLineIdProperty={objectType.timeLineIdProperty} 
                  entityView={objectType.entityView} 
                  log_={objectType.log_} 
                  method={objectType.method} 
                  Loading={setLoading}/>
              </>
            ))
            }
            </Grid>
          </Grid>
        ),
      });

    if(userPrivileges.error)
      childrenForm.push(
        {
          label: "Incidencias",
          tabContent: (
            <Grid container style={{
              display: "flex"
            }}>
              <MonitoringView onlyContent={true} user={user}/>
            </Grid>
          ),
        });

  return (
    <div>
      <FormLayout
        handleSubmit={(e) => e.preventDefault()}
        isEditing={false}
        confirmInactivate={confirmInactivate}
        setConfirmInactivate={setConfirmInactivate}
        modalMessage={`¿Desea modificar esta configuración?`}
        handleAccept={(e) => handleAccept(e)}
      >
        <TabComponent
          aria={"tracings tabs"}
          handleChangeTab={handleChangeTab}
          tab={tab}
          children={childrenForm}
        />
      </FormLayout>
    </div>
  );
};

//#region entities's declarations 
TracingForm.propTypes = {
  
};

const mapStateToProps = (state) => ({
  transactionTypesResponse: state.objectTypesReducer.getTransactionTypesResponse
});

const mapDispatchToProps = {
  getTransactionTypesByEnterprise
};

export default connect(mapStateToProps, mapDispatchToProps)(TracingForm);
//#endregion